import type { MandatoryUnitUserCertificateStatus } from 'src/types/examination';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

import { MandatoryUnitUserCertificateStatusSchema } from 'src/types/examination';

export function useMandatoryUnitUserCertificateStatus(mandatoryUnitId?: number) {
  const { data, error, isLoading, mutate } = useSWR<MandatoryUnitUserCertificateStatus>(
    mandatoryUnitId ? ['mandatoryUnitUserCertificateStatus', mandatoryUnitId] : null,
    async () => {
      const rawData = await fetcher(endpoints.examination.userCertificateStatus(mandatoryUnitId!));
      return MandatoryUnitUserCertificateStatusSchema.parse(rawData);
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    certificateStatus: data,
    isLoading,
    error,
    refetch: mutate,
  };
}
